/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
// ==============================================
// ==================Import======================
// ==============================================

// ==================Dependancies React=================
import {
  forwardRef,
  useRef,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';

// ==================Actions=================
import { setGreaterAlt, setLessAlt } from '../../../actions/site';

export default forwardRef((props, ref) => {
  // ==================HOOKS=================
  const dispatch = useDispatch();
  const greaterAlt = useSelector((state) => state.site.filter.greaterAlt);
  const lessAlt = useSelector((state) => state.site.filter.lessAlt);
  const inputRef = useRef(null);

  // Remove precedent filter and save new value selected by user
  const onInputBoxChanged = (input) => {
    if (input.target.value === '') {
      dispatch(setGreaterAlt(''));
      // Remove the filter
      props.parentFilterInstance((instance) => {
        instance.onFloatingFilterChanged(null, null);
      });
      return;
    }
    dispatch(setGreaterAlt(Number(input.target.value)));
    props.parentFilterInstance((instance) => {
      instance.onFloatingFilterChanged('greaterThan', input.target.value);
    });
  };

  const onInputLonBoxChanged = (input) => {
    if (input.target.value === '') {
      dispatch(setLessAlt(''));
      // Remove the filter
      props.parentFilterInstance((instance) => {
        instance.onFloatingFilterChanged(null, null);
      });
      return;
    }
    dispatch(setLessAlt(Number(input.target.value)));
    props.parentFilterInstance((instance) => {
      instance.onFloatingFilterChanged('lessThan', input.target.value);
    });
  };

  // ==================Styles=================
  const style = {
    color: props.color,
    width: '100%',
    maxHeight: '24px',
    margin: 'auto',
    marginTop: '0.2em',
    border: '1px solid gray',
    borderRadius: '3px',
    display: 'block',
  };

  const containerStyle = {
    display: 'flex',
    flexWrap: 'wrap',
  };

  return (
    <div
      style={containerStyle}
    >
      <input
        placeholder="greater than ..."
        ref={inputRef}
        value={greaterAlt}
        style={style}
        type="number"
        min="0"
        onInput={onInputBoxChanged}
      />
      <input
        placeholder="less than ..."
        ref={inputRef}
        value={lessAlt}
        style={style}
        type="number"
        min="0"
        onInput={onInputLonBoxChanged}
      />
    </div>
  );
});
